import styled from '@emotion/styled';

export const ConsentLink = styled.a`
  color: #1890ff;
  text-decoration: underline;
`;
